import React from 'react';
import { Pagination, Select } from '@mantine/core';
import MantineFlex from './flex';

const MantinePagination = (props: any) => {
  const { total, onChange, siblings, color, withEdges, className, size, value, onChangeSelect, valueSelect, sizeSelect } = props;
  
  return (
    <MantineFlex gap={15}>
      <Select
        defaultValue={`${valueSelect}`}
        onChange={onChangeSelect}
        data={['5', '10', '20', '50']}
        placeholder="Select page size"
        size={sizeSelect}
        className={"w-full max-w-20"}
      />
      <Pagination
        total={total}
        onChange={onChange}
        color={color}
        withEdges={withEdges}
        className={className}
        size={size}
        value={value}
        siblings={siblings}
      />
    </MantineFlex>
  );
};

export default MantinePagination;
